"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSOL = void 0;
exports.WSOL = {
    symbol: 'WSOL',
    mintAddress: 'So11111111111111111111111111111111111111112',
    decimals: 9,
};
